<button class="toggle-btn" (click)="onToggleClick()">
  <span class="toggle-btn-label">{{ isExpanded ? 'Hide' : 'Show' }}</span>
</button>
